<template>
  <div class="container page binding-channel-page bind-erc20-page">
    <van-nav-bar title="Bind ERC20" class="nav-bar">
      <template #left>
        <button class="nav-back" type="button" aria-label="Back" @click="back()">
          <van-icon name="arrow-left" />
        </button>
      </template>
    </van-nav-bar>
    <div class="wrapper">
      <div class="binding-hero">
        <div class="binding-icon"><van-icon name="exchange" /></div>
        <div>
          <div class="binding-kicker">Victoria payout</div>
          <h1>ERC20 wallet</h1>
          <p>Bind a verified ERC20 address for secure withdrawals.</p>
        </div>
      </div>
      <van-form @submit="onSubmit">
        <van-field
          v-model="formData.wallet_address"
          name="wallet_address"
          label="Wallet Address"
          placeholder="Please enter ERC20 wallet address"
          :rules="[{ required: true, message: 'Please enter wallet address' }]"
        />
        <van-field
          v-model="formData.holder_name"
          name="holder_name"
          label="Holder Name"
          placeholder="Please enter holder name (optional)"
        />
        <van-field
          v-model="formData.mobile"
          name="mobile"
          label="Mobile Number"
          placeholder="Please enter mobile number"
          type="tel"
          :rules="[{ required: true, message: 'Please enter mobile number' }]"
        />
        <div class="tips">
          <p class="tips-title"><van-icon name="shield-o" /> Security tips</p>
          <p>1. Please ensure the wallet address is accurate</p>
          <p>2. Only supports ERC20 network addresses</p>
          <p>3. Holder name defaults to account real name</p>
        </div>
        <div class="submit-wrapper">
          <van-button round block type="primary" native-type="submit" class="submit-btn">
            Confirm Binding
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formData: {
        wallet_address: '',
        holder_name: '',
        mobile: ''
      },
      from: ''
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    onSubmit() {
      const params = {
        channel_type: 'erc20',
        wallet_address: this.formData.wallet_address,
        mobile: this.formData.mobile
      };
      
      if (this.formData.holder_name) {
        params.holder_name = this.formData.holder_name;
      }
      
      this.$http({
        method: 'post',
        data: params,
        url: 'bindWithdrawalChannel'
      }).then(res => {
        if (res.code === 200) {
          this.$toast.success(res.msg);
          setTimeout(() => {
            this.$router.back();
          }, 1500);
        } else {
          this.$toast.fail(res.msg);
        }
      }).catch(() => {
        this.$toast.fail('Binding failed, please try again later');
      });
    }
  },
  created() {
    this.from = this.$route.query.from;
    if (!localStorage.getItem('token')) {
      this.$router.push({path: '/Login'});
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.wrapper {
  padding: 0.2rem;
  background-color: #f7f8fa;
  min-height: calc(100vh - 0.88rem);
}
.van-form {
  background: #fff;
  border-radius: 0.16rem;
  overflow: hidden;
}
::v-deep .van-cell {
  font-size: 0.28rem;
  padding: 0.2rem 0.32rem;
}
::v-deep .van-field__label {
  width: 1.6rem;
  color: #323233;
}
::v-deep .van-field__control {
  color: #323233;
}
.tips {
  margin-top: 0.3rem;
  padding: 0.24rem;
  background: #fff;
  border-radius: 0.16rem;
}
.tips p {
  font-size: 0.24rem;
  color: #969799;
  line-height: 0.4rem;
  margin: 0;
}
.tips p:first-child {
  color: #323233;
  font-weight: 500;
  margin-bottom: 0.16rem;
}
.submit-wrapper {
  margin-top: 0.6rem;
  padding: 0 0.32rem;
}
.submit-btn {
  height: 0.88rem;
  font-size: 0.32rem;
  background: linear-gradient(270deg, #5b60df, #5b60df);
  border: none;
}
</style>
